import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import logoImage from "Assets/Images/placeholder.png";

function LazyLoadImg({
  imgSrc,
  imgAlt,
  imgHeight,
  imgWidth,
  classname,
  className,
  style,
  wrapperClassName,
  wrapperProps,
}: any) {
  return (
    <LazyLoadImage
      effect="blur"
      src={imgSrc}
      alt={imgAlt && imgAlt}
      height={imgHeight && imgHeight}
      width={imgWidth && imgWidth}
      placeholderSrc={logoImage}
      // accept both `className` and the legacy `classname` prop
      className={className || classname}
      style={style && style}
      wrapperClassName={wrapperClassName}
      wrapperProps={wrapperProps}
      // fall back to the logo if the real image fails to load (404 / broken)
      onError={(e: any) => {
        if (e?.currentTarget && e.currentTarget.src !== logoImage) {
          e.currentTarget.src = logoImage;
        }
      }}
    />
  );
}

export default LazyLoadImg;